import React, { Component } from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import withStyles from "@material-ui/core/styles/withStyles";

import { connect } from "react-redux";
import { pushCheckedPOI } from "../../actions/portal";
import PropTypes from "prop-types";

import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

class leftpanelPOI extends Component {

  constructor(props) {
    super(props);
    this.state = {
      checkedPOI: this.props.checkedPOI
    };
  }

  handleToggle(value) {
    this.setState({ checkedPOI: !this.state.checkedPOI });
    console.log(value);
    this.props.pushCheckedPOI(!this.state.checkedPOI);
  }

  render() {
    const { classes } = this.props;
    return (
      <div style={{ padding: "5px" }}>
        <FormControlLabel
          control={
            <Checkbox
              tabIndex={-1}
              checked={this.state.checkedPOI}
              onClick={() => this.handleToggle(!this.state.checkedPOI)}
              checkedIcon={<Check className={classes.checkedIcon} />}
              icon={<Check className={classes.uncheckedIcon} />}
              classes={{
                checked: classes.checked,
                root: classes.checkRoot
              }}
            />
          }
          classes={{
            label: classes.label
          }}
          label="Vessel"
        />
      </div>
    );
  }
}

leftpanelPOI.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    rightPanel: state.rightPanel
  };
}

export default withStyles(regularFormsStyle)(
  connect(
    mapStateToProps,
    { pushCheckedPOI }
  )(leftpanelPOI)
);
